import { http } from '..';
import { paginatedData } from '../../utils/helper-interface';


 interface GetFXRatePayloadBase {
    currencyFrom: string;
    currencyTo: string;
    type?: FxTransactionTypes;
}

interface GetFXRatePayloadWithSend extends GetFXRatePayloadBase {
    amountToSend: number;
    amountToReceive?: never;
}

interface GetFXRatePayloadWithReceive extends GetFXRatePayloadBase {
    amountToReceive: number;
    amountToSend?: never;
}

export type GetFXRatePayload = GetFXRatePayloadWithSend | GetFXRatePayloadWithReceive;

export interface createTransactionPayload {
    destinationCurrencyCode: string;
    expectedDestinationAmount: number;
    expectedRate: number;
    paymentPurposeId: string;
    paymentReference?: string;
    sourceAmount: number;
    sourceCurrencyCode: string;
    transactionDestination: number;
    transactionSource: number;
    transactionType: number;
    transactionDocumentsUrl: string[];
    notifyParties: string[];
}

export interface getTransactionPayload extends paginatedData {}

export interface getTransactioByReferencePayload {
    corporateId: number;
    transactionReference: string;
}

export interface getAdminWalletsPayload {
    type: 'PROVIDER' | 'POOL' | 'INTERNAL';
}

export enum FxTransactionTypes {
    WALLET_CONVERSION = 'WALLET_CONVERSION',
    BENEFICIARY_FUNDING_DIRECT = 'BENEFICIARY_FUNDING_DIRECT',
    BENEFICIARY_FUNDING_CONVERSION = 'BENEFICIARY_FUNDING_CONVERSION'
}

export const getFXRate = (data: GetFXRatePayload) => {
    return http.get('/fx/rate', {
        params: {
            ...data
        }
    });
};

/**
 * Gets transaction based on reference
 * @param data Object
 * @returns ttp response
 */
export const getTransactioByReference = (
    data: getTransactioByReferencePayload
) => {
    return http.get(
        `/wallet/transaction/${data.transactionReference}/corporate/${data.corporateId}`
    );
};